import {
  Brands,
  FeaturedCategory,
  Hero,
  MoreProducts,
  NewStock,
  TopSelling,
  WhyChooseUs,
} from "@/components/views/landing-page";

export const LandingPage = () => {
  return (
    <>
      <Hero />
      <FeaturedCategory />
      <TopSelling />
      <Brands />
      <NewStock />
      <WhyChooseUs />
      <MoreProducts />
    </>
  );
};
